import React, { ReactNode } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';

import Laanekostnad from '../components/laanekostnad';
import Laaneramme from '../components/laaneramme';
import KalkulatorState from './kalkulatorState';

const kalkulator = (): ReactNode => (
    <KalkulatorState>
        <HashRouter>
            <Routes>
                <Route path="/kostnad" element={<Laanekostnad />} />
                <Route path="/*" element={<Laaneramme />} />
            </Routes>
        </HashRouter>
    </KalkulatorState>
);

export default kalkulator;
